import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.41734 5.83342L6.99984 1.16675L5.58234 5.83342H1.1665L4.7715 8.40592L3.40067 12.8334L6.99984 10.0976L10.6048 12.8334L9.234 8.40592L12.8332 5.83342H8.41734Z",
		fill: "#172931"
	})
});
export default SvgStar;
